export default __webpack_public_path__ + "static/media/321.b520eccc.png";